// @flow

import React from 'react';
import { withHelmet } from 'infrastructure/seo/Helmet';

type Props = {
  styles: any,
  scriptSrc: string,
  scriptWidgetId: string,
  scriptWidgetAlias: string
};

function JoinStories({ styles, scriptSrc, scriptWidgetId, scriptWidgetAlias }: Props) {
  return (
    <div className="join-stories">
      <div id={scriptWidgetId} style={styles}></div>
    </div>
  );
}

export default withHelmet(JoinStories)((Helmet, pageProps) => {
  return (
    <Helmet>
      <script
        src={pageProps.scriptSrc}
        data-join-widget-id={pageProps.scriptWidgetId}
        data-join-widget-alias={pageProps.scriptWidgetAlias}
        type="text/javascript"
      ></script>
    </Helmet>
  );
});
